var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunbelt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.304 283.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.18 155.02 L207.12 87.27 L237.64 56.75 L146.4 56.48 L146.4 9.12 L78.97 76.23 L49.64 46.85 L49.64 139.23           L0 139.23 L66.38 206.07 L32.07 240.74 L129.88 240.74 L130.16 283.67 L194.89 219.34 L227.87 252.74 L227.87           155.02 L274.18 155.02 ZM161.36 182.8 A42.9746 42.9746 0 0 1 119.07 186.27 C102.37 177.56 95.67 159.22 97.67           141.79 A41.0585 41.0585 0 0 1 117.24 113.28 A45.1187 45.1187 0 0 1 157.03 112.18 A41.9709 41.9709 0 0 1           179.33 149.04 C178.6 162.45 173.72 175.18 161.36 182.8 Z",
    fill: "#ffdd00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunbelt);
export default __webpack_public_path__ + "static/media/Sunbelt.76bc1d41.svg";
export { ForwardRef as ReactComponent };